module.exports = __webpack_public_path__ + "static/img/pc-vilocal-no-login-banner.b019ec5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/vilocal/pc-vilocal-no-login-banner.png
// module id = Rq6W
// module chunks = 0